import * as React from 'react';
import PropertyInfoForm from './PropertyInfoForm';
import PropertyConfigurationTab from './PropertyConfigurationTab';
import LoadingOverlay from '../../../common/LoadingOverlay';
import UnitTypeTab from './UnitTypeTab';
import AdvancedTab from './AdvancedTab';
import {
    getPropertyById,
    updatePropertyConfiguration,
    updateProperty,
    deleteProperty,
    Property,
    TimeZone,
    DayConfiguration,
    TourInterval,
    PropertyInfo
} from '../../../../api/Property';
import TabbedPage, { LabeledPage } from '../../../common/TabbedPage';
import * as moment from 'moment';
import Button from '../../../common/form/Button';
import {
    AdvancedConfiguration,
    BrivoPropertyConfiguration,
    getAdvancedConfiguration
} from '../../../../api/PropertyIntegration';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import LeaseMatchUploadWidget from './LeaseMatchUploadWidget';
import { Company } from '../../../../api/Company';
import { userIsCompanyAdmin, userIsSystemAdmin, userIsCompanyManageUser, userIsPropertyManageUser, userIsSystemManageUser } from '../../../../utilities/identity';
import UnitMapConfigurationTab from './UnitMapConfigurationTab';
import { getUnitMapConfigurationById, UnitMapConfiguration } from '../../../../api/UnitMap';
import UnitManagementTab from './UnitManagement';
													  														
interface State {
    property?: Property;
    advancedConfiguration?: AdvancedConfiguration;
    unitMapConfiguration?: UnitMapConfiguration;
    companiesList?: Company[];
    successMessage?: string;
    wasPropertyInfoFormValidated: boolean;
    wasPropertyConfigurationFormValidated: boolean;
    wasAdvancedConfigurationFormValidated: boolean;
    wasUnitMapConfigurationFormValidated: boolean;
    isLoading: boolean;
    previousBrivoConfiguration?: BrivoPropertyConfiguration;
}

interface Props {
    propertyId: number;
    createUser: (companyId: number) => void;
    onPropertyDelete: () => void;
    availableTimeZones?: TimeZone[];
    onErrorMessageUpdate: (errorMessage?: string) => void;
    errorMessage?: string;
    isAdvanceTab?: boolean;
    isDisabled?: boolean;
}

export const defaultDayConfiguration: DayConfiguration = {
    isTouringEnabledToday: true,
    maxTourCount: 1,
    tourLength: 30,
    postTourDowntime: 0,
    tour24: {
        toursEnabled: false,
        startTime: '8:00 AM',
        endTime: '8:00 PM',
        blockedTimeEnabled: false,
        blockedStartTime: '12:00 PM',
        blockedEndTime: '1:00 PM',
        propertyHoursOpen: false,
        propertyHoursStartTime: '9:00 AM',
        propertyHoursEndTime: '6:00 PM'
    }
};

const momentFormat = 'hh:mm A';
const intervalIsValid = (interval?: TourInterval) => {
    if (!interval) {
        return true;
    }
    let start = moment(interval.startTime, momentFormat);
    let end = moment(interval.endTime, momentFormat);
    if (start.isAfter(end)) {
        return false;
    }
    if (!interval.blockedTimeEnabled || (!interval.blockedStartTime && !interval.blockedEndTime)) {
        return true;
    }
    if (!interval.blockedStartTime || !interval.blockedEndTime) {
        return false;
    }
    let blockedStart = moment(interval.blockedStartTime, momentFormat);
    let blockedEnd = moment(interval.blockedEndTime, momentFormat);
    return !(
        blockedStart.isAfter(blockedEnd) ||
        blockedStart.isAfter(end) ||
        blockedEnd.isBefore(start)
    );
};

class EditPropertyPane extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLoading: true,
            wasPropertyConfigurationFormValidated: false,
            wasPropertyInfoFormValidated: false,
            wasAdvancedConfigurationFormValidated: false,
            wasUnitMapConfigurationFormValidated: false
        };

        this.loadProperty = this.loadProperty.bind(this);
        this.loadAdvancedConfiguration = this.loadAdvancedConfiguration.bind(this);
        this.handlePropertyChange = this.handlePropertyChange.bind(this);
        this.handleUnitMapChange = this.handleUnitMapChange.bind(this);
        this.handlePropertyConfigurationChange = this.handlePropertyConfigurationChange.bind(this);
        this.handlePropertyInfoSubmit = this.handlePropertyInfoSubmit.bind(this);
        this.handlePropertyConfigurationSubmit = this.handlePropertyConfigurationSubmit.bind(this);
        this.dayIsValid = this.dayIsValid.bind(this);
        this.handlePropertyDelete = this.handlePropertyDelete.bind(this);
        this.handleAdvancedChange = this.handleAdvancedChange.bind(this);
		this.handleMultipleChange = this.handleMultipleChange.bind(this);											 
        this.onTabbedPageChange = this.onTabbedPageChange.bind(this);
        this.refreshProperty = this.refreshProperty.bind(this);
    }
    
    componentDidMount() {
        this.loadProperty();

        this.loadAdvancedConfiguration();
        this.loadUnitMapConfiguration();
    }
    refreshProperty() {
        this.loadProperty();
    }

    componentDidUpdate(prevProps: Props) {
        if (prevProps.propertyId !== this.props.propertyId) {
            this.loadProperty();
            this.loadAdvancedConfiguration();
            this.loadUnitMapConfiguration();
        }
    }
    isFormDisabled = (): boolean => {
        return (
            this.props.isDisabled || (userIsCompanyManageUser() ||  userIsPropertyManageUser() || userIsSystemManageUser()));
    };

    render() {
        let pages: LabeledPage[] = [];

        if (this.state.property) {
           if(userIsCompanyAdmin()){

            pages = [
                {
                    tabLabel: 'Basic Info',
                    render: () => (
                          <Button
                                text="Add user for property"
                                addlClassName="btn-primary"
                                onClick={() =>
                                    this.props.createUser(
                                        this.state.property!.companyId
                                    )
                                }
                                    disabled={this.isFormDisabled()}
                                
												 
                            />
                    )
                }
            ]

           }
           if(userIsSystemAdmin()){
            pages = [
                {
                    tabLabel: 'Basic Info',
                    render: () => (
                        <PropertyInfoForm
                            {...this.state.property!}
                            advancedConfiguration = {this.state.advancedConfiguration!}
                            availableTimeZones={this.props.availableTimeZones}
                            onChange={this.handlePropertyChange}
                            onSubmit={this.handlePropertyInfoSubmit}
                            wasFormValidated={this.state.wasPropertyInfoFormValidated}
                            onFormValidated={() =>
                                this.setState({ wasPropertyInfoFormValidated: true })
                            }
                            newProperty={false}
                            onPropertyDelete={this.handlePropertyDelete}
                            errorMessage={this.props.errorMessage}
                            additionalTopContent={
                                <Row>
                                    <Col xs={4}>
                                        <Button
                                            text="Add user for property"
                                            addlClassName="btn-primary"
                                            onClick={() =>
                                                this.props.createUser(
                                                    this.state.property!.companyId
                                                )
                                                }
                                                disabled={this.isFormDisabled()}
															 
                                        />
                                    </Col>
                                    <Col>
                                        <LeaseMatchUploadWidget
                                            propertyId={this.state.property!.id}
                                            lastUpload={this.state.property!.leaseUploadStats}
                                        />
                                    </Col>
                                </Row>
                            }
                        />
                    )
                }
            ];
           } 

            if (this.props.propertyId && this.state.property.propertyConfiguration) {
                pages = [
                    ...pages,
                    {
                        tabLabel: 'Hours',
                        render: () => (
                            <PropertyConfigurationTab
                                propertyConfiguration={this.state.property!.propertyConfiguration}
                                onChange={this.handlePropertyConfigurationChange}
                                onSubmit={this.handlePropertyConfigurationSubmit}
                                wasFormValidated={this.state.wasPropertyConfigurationFormValidated}
                                errorMessage={this.props.errorMessage}
                            />
                        )
                    }
                ];
            }
            if (this.props.propertyId && (userIsSystemAdmin() || userIsCompanyAdmin())) {
                pages = [
                    ...pages,
                    {
                        tabLabel: 'Unit Types',
                        render: () => <UnitTypeTab propertyId={this.props.propertyId} />
                    }
                ];
            }
            if (this.props.propertyId) {
                pages = [
                    ...pages,
                    {
                        tabLabel: 'Unit Management',
                        render: () => <UnitManagementTab propertyId={this.props.propertyId} propertyInfo={this.state.property as PropertyInfo} advancedConfiguration={this.state.advancedConfiguration as AdvancedConfiguration} refreshProperty={this.refreshProperty}  />
                    }
                ];
            }
            if (this.props.propertyId && userIsSystemAdmin() && this.state.unitMapConfiguration) {
                let unitMapConfiguration = this.state.unitMapConfiguration;
                pages = [
                    ...pages,
                    {
                        tabLabel: 'Map Configuration',
                        render: () => (
                            <UnitMapConfigurationTab
                                propertyId={this.props.propertyId}
                                setIsLoading={isLoading => this.setState({ isLoading: isLoading })}
                                errorMessage={this.props.errorMessage}
                                setError={error => this.props.onErrorMessageUpdate(error)}
                                unitMapConfiguration={unitMapConfiguration}
                                isLoading={this.state.isLoading}
                                onChange={this.handleUnitMapChange}
                            />
                        )
                    }
                ];
            }
            if (this.props.propertyId && this.state.advancedConfiguration && userIsSystemAdmin()) {
                let advancedConfiguration = this.state.advancedConfiguration;

                pages = [
                    ...pages,
                    {
                        tabLabel: 'Advanced',
                        render: () => (
                            <AdvancedTab
                                advancedConfiguration={advancedConfiguration}
                                companyId={this.state.property!.companyId}
                                wasFormValidated={this.state.wasAdvancedConfigurationFormValidated}
                                onFormValidated={() => this.setState({
                                    wasAdvancedConfigurationFormValidated: true
                                })}
                                previousBrivoConfiguration={this.state.previousBrivoConfiguration}
                                onChange={this.handleAdvancedChange}
                                errorMessage={this.props.errorMessage}
                                propertyId={this.props.propertyId}
                                reload={this.loadAdvancedConfiguration}
                                setError={error => this.props.onErrorMessageUpdate(error)}
                                setIsLoading={isLoading => this.setState({ isLoading: isLoading })}
                                companiesList={this.state.companiesList}
                                property={this.state.property} 
                                onMultipleChange={this.handleMultipleChange}                            
                                />
                        )
                    }
                ];
            }
        }
        const advanceIndex = pages.findIndex(page => page.tabLabel === 'Advanced');
        const {isAdvanceTab} = this.props;
        console.log('advanceIndex', advanceIndex, isAdvanceTab);
        return (
            <div>
                <LoadingOverlay
                    show={this.state.isLoading || !this.state.property}
                    inBootstrapColumn={true}
                />
                 <TabbedPage pages={pages} onPageChange={this.onTabbedPageChange} activeIndex={isAdvanceTab && advanceIndex ? advanceIndex : 0} />
            </div>
        );
    }

    async loadProperty() {
        this.setState({
            property: undefined,
            wasPropertyConfigurationFormValidated: false,
            wasAdvancedConfigurationFormValidated: false,
            isLoading: true
        });

        let propertyResult = await getPropertyById(this.props.propertyId);

        if (propertyResult.success && propertyResult.data) {
            this.setState({
                property: propertyResult.data,
                isLoading: false,
                successMessage: undefined
            });
        } else if (propertyResult.error) {
            this.props.onErrorMessageUpdate(propertyResult.error);
        }
    }

    async loadAdvancedConfiguration() {
        this.setState({
            wasAdvancedConfigurationFormValidated: false,
            isLoading: true
        });

        let advancedConfigResult = await getAdvancedConfiguration(this.props.propertyId);

        if (advancedConfigResult.success && advancedConfigResult.data) {
            this.setState({
                advancedConfiguration: advancedConfigResult.data,
                isLoading: false,
                successMessage: undefined,
                previousBrivoConfiguration: advancedConfigResult.data.brivoPropertyConfiguration
            });
        } else if (advancedConfigResult.error) {
            this.props.onErrorMessageUpdate(advancedConfigResult.error);
        }
    }

    async loadUnitMapConfiguration() {
        this.setState({
            wasUnitMapConfigurationFormValidated: false,
            isLoading: true
        });

        let unitMapConfigResult = await getUnitMapConfigurationById(this.props.propertyId);

        if (unitMapConfigResult.success && unitMapConfigResult.data) {
            this.setState({
                unitMapConfiguration: unitMapConfigResult.data,
                isLoading: false,
                successMessage: undefined
            });
        } else if (unitMapConfigResult.error) {
            this.props.onErrorMessageUpdate(unitMapConfigResult.error);
        }
    }

    private async handlePropertyInfoSubmit() {
        this.setState({
            isLoading: true
        });
        if (!this.state.property) {
            return;
        }

        let property = this.state.property;
        if (!property.requestPetInformation) {
            property.petPolicy = undefined;
            this.handlePropertyChange('petPolicy', undefined);
        }
        let result = await updateProperty(this.props.propertyId, this.state.property);
        if (result.success) {
            this.setState({
                successMessage: 'Update successful',
                isLoading: false
            });
        } else if (result.error) {
            this.setState({ isLoading: false });
            this.props.onErrorMessageUpdate(result.error);
        }
    }

    private onTabbedPageChange() {
        this.props.onErrorMessageUpdate('');
    }

    private handlePropertyConfigurationSubmit(e: React.SyntheticEvent<HTMLFormElement>) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.state.property || !this.state.property.propertyConfiguration) {
            this.props.onErrorMessageUpdate('Cannot submit blank property configuration');
            return;
        }

        let days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
        if (days.some(day => !this.dayIsValid(day))) {
            this.props.onErrorMessageUpdate(
                'Please ensure all days are valid, with starts before ends, ' +
                    'and disabled windows within active windows if enabled.'
            );
            return;
        }

        this.setState({
            wasPropertyConfigurationFormValidated: true
        });

        if (!this.props.propertyId) {
            return;
        }
        updatePropertyConfiguration(
            this.props.propertyId,
            this.state.property.propertyConfiguration
        ).then(result => {
            if (result.success) {
                this.setState({ successMessage: 'Property Configuration Update successful' });
            } else {
                this.props.onErrorMessageUpdate(result.error);
            }
        });
    }

    private handlePropertyChange(
        inputName: string,
        newValue: string | boolean | number | undefined
    ) {
        this.setState({
            property: this.state.property
                ? {
                      ...this.state.property,
                      [inputName]: newValue
                  }
                : undefined,
            successMessage: undefined
        });
		
        this.props.onErrorMessageUpdate(undefined);
    }

    private handlePropertyConfigurationChange(
        dayName: string,
        dayFieldName: string,
        newValue: string | boolean | number,
        secondDayFieldName?: string,
        secondDayFieldValue?: string
    ) {
        if (this.state.property && this.state.property.propertyConfiguration) {
            this.props.onErrorMessageUpdate(undefined);

            if (
                newValue !== undefined &&
                newValue !== null &&
                newValue !== true &&
                newValue !== false &&
                !isNaN(newValue as number)
            ) {
                newValue = parseInt(newValue.toString(), 10);
            }

            let newDay = {
                ...this.state.property.propertyConfiguration![dayName],
                [dayFieldName]: newValue
            };
            if (secondDayFieldName) {
                newDay[secondDayFieldName] = secondDayFieldValue;
            }

            this.setState({
                successMessage: undefined,
                property: {
                    ...this.state.property,
                    propertyConfiguration: {
                        ...this.state.property.propertyConfiguration,
                        [dayName]: newDay
                    }
                }
            });
        }
    }
    private handleMultipleChange(changes: { [key: string]: number | string | boolean | undefined }) {
        if (this.state.advancedConfiguration) {
            const updatedConfiguration = {
                ...this.state.advancedConfiguration,
                ...changes
            };
    
            this.setState({
                advancedConfiguration: updatedConfiguration,
                successMessage: undefined
            });
        }
    }
																									 
    private handleAdvancedChange(name: string, value: number | string | boolean | undefined) {
        if (this.state.advancedConfiguration) {
           this.setState({
                ...this.state,
                advancedConfiguration: this.state.advancedConfiguration
                    ? {
                          ...this.state.advancedConfiguration,
                          [name]: value
                      }
                    : undefined,
                successMessage: undefined
            });
        }
    }

    private handleUnitMapChange(newConfig?: UnitMapConfiguration) {
        this.setState({
            ...this.state,
            unitMapConfiguration: newConfig,
            successMessage: undefined
        });
    }

    private dayIsValid(day: string) {
        var dayConfiguration =
            this.state.property &&
            this.state.property.propertyConfiguration &&
            (this.state.property.propertyConfiguration[day] as DayConfiguration | undefined);
        if (!dayConfiguration) {
            return false;
        }

        if (!dayConfiguration.isTouringEnabledToday) {
            return true;
        }

        if (
            !(
                Number.isInteger(dayConfiguration.tourLength) &&
                Number.isInteger(dayConfiguration.maxTourCount)
            )
        ) {
            return false;
        }

        return intervalIsValid(dayConfiguration.tour24);
    }

    private async handlePropertyDelete() {
        if (!this.props.propertyId) {
            return;
        }
        if (confirm('This will permanently delete this property.')) {
            this.setState({
                isLoading: true
            });
            var deleteResult = await deleteProperty(this.props.propertyId);
            if (deleteResult.success) {
                this.props.onPropertyDelete();
            } else if (deleteResult.error) {
                this.props.onErrorMessageUpdate(deleteResult.error);
                this.setState({
                    successMessage: undefined,
                    isLoading: false
                });
            }
        }
    }
}

export default EditPropertyPane;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/EditPropertyPane.tsx